import { constant } from "./SubscriptionActionConstants";
let initialState = {
    getSubscriptionPlansInProgress: false,
    cancelSubscriptionInProgress: false,
    addMoreTimetablesToSubscriptionInProgress: false,
    getSubscriptionInProgress: false,
    getSubscriptionFailed: false,
    addMoreSectionsToSubscriptionInProgress:false
}

export const SubscriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case constant.ADD_MORE_SECTIONS_TO_SUBSCRIPTION_IN_PROGRESS:
            return { ...state, addMoreSectionsToSubscriptionInProgress: true };
        case constant.ADD_MORE_SECTIONS_TO_SUBSCRIPTION_COMPLETE:
            return { ...state, addMoreSectionsToSubscriptionInProgress: false, addMoreSectionsPackage: action.data };
        case constant.ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_IN_PROGRESS:
            return { ...state, addMoreTimetablesToSubscriptionInProgress: true };
        case constant.ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_COMPLETE:
            return { ...state, addMoreTimetablesToSubscriptionInProgress: false, addMoreTimetablesPackage: action.data };
        case constant.CANCEL_SUBSCRIPTION_IN_PROGRESS:
            return { ...state, cancelSubscriptionInProgress: true };
        case constant.CANCEL_SUBSCRIPTION_COMPLETE:
            return { ...state, cancelSubscriptionInProgress: false };
        case constant.GET_SUBSCRIPTION_IN_PROGRESS:
            return { ...state, getSubscriptionInProgress: true };
        case constant.GET_SUBSCRIPTION_COMPLETE:
            return { ...state, getSubscriptionInProgress: false };
        case constant.GET_SUBSCRIPTION_FAILED:
            return { ...state, getSubscriptionFailed: true, getSubscriptionInProgress: false };
        default:
            return state
    }
}

export default SubscriptionReducer;